import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Google from '@mui/icons-material/Google';
import CalendarMonth from '@mui/icons-material/CalendarMonth';
import Download from '@mui/icons-material/Download';
import config from '../config';

type Props = {
  path: string;
};

const CalendarLinks = ({ path }: Props) => {
  return (
    <List disablePadding>
      <ListItemButton
        component="a"
        href={`https://www.google.com/calendar/render?cid=${encodeURIComponent(`webcal://${config().universal.primaryDomain}${path}`)}`}
      >
        <ListItemIcon><Google /></ListItemIcon>
        <ListItemText primary="Google Calendar" secondary="Desktop or iPhone" />
      </ListItemButton>
      <ListItemButton
        component="a"
        href={`webcal://${config().universal.primaryDomain}${path}`}
      >
        <ListItemIcon><Google /></ListItemIcon>
        <ListItemText primary="Google Calendar" secondary="Android" />
      </ListItemButton>
      <ListItemButton
        component="a"
        href={`webcal://${config().universal.primaryDomain}${path}`}
      >
        <ListItemIcon><CalendarMonth /></ListItemIcon>
        <ListItemText primary="iPhone / Mac / Outlook / Other" secondary="Uses webcal protocol" />
      </ListItemButton>
      <ListItemButton
        component="a"
        href={`${config().universal.baseUri}${path}`}
      >
        <ListItemIcon><Download /></ListItemIcon>
        <ListItemText primary="Download Calendar File" secondary=".ics file" />
      </ListItemButton>
    </List>
  );
};

export default CalendarLinks;
